import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonLinkComponent } from "./sidebar-button-link.component";

@Component({
    selector: "sidebar-account",
    imports: [],
    templateUrl: "./sidebar-button-link.component.html"
})
export class SidebarAccountButtonComponent extends SidebarButtonLinkComponent {
    public constructor() { 
        super("Account", SvgIcon.Settings, "/account", false); 
    }
}